import { initAudio } from '../audio/init_audio'
import { initMarkup } from '../markup/init_markup'
import { initTutorialSections } from '../tutorial_sections/init_tutorial_sections'
import '../other_actions_dropdown/tutorial_actions_dropdown'

SOPHIA.initAudio = initAudio
SOPHIA.initMarkup = initMarkup
SOPHIA.initTutorialSections = initTutorialSections
